import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { Button } from '@mui/material';
import { INV_TRANSFER_ORDER_CONFIG, INV_TRANSFER_ORDER_FIELDS, INV_TRANSFER_ORDER_SCONFIG } from '../../Models/Inventory';
import Modal from '../Modals';
import { useContext, useState } from 'react';
import { NotificationContext } from '../../contexts/NotificationContext';


export const TransferOrder = () => {
    const [showTransferForm, setShowTransferForm] = useState(false)

    const config = INV_TRANSFER_ORDER_SCONFIG

    const getTransferOrderColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return INV_TRANSFER_ORDER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "purposeOfTransfer":
                    minWidth = 150
                    break;
                case "sourceBusinessunit":
                    minWidth = 150
                    break;
                case "targetBusinessunit":
                    minWidth = 150
                    break;
                case "transactionLocation":
                    minWidth = 160
                    break;
                case "sourceLocation":
                    minWidth = 120
                    break;
                case "targetLocation":
                    minWidth = 110
                    break;
                case "transporterBU":
                    minWidth = 120
                    break;
                case "transporterReference":
                    minWidth = 160
                    break;
                case "receiptReference":
                    minWidth = 130
                    break;
                case "gtTransactionType":
                    minWidth = 160
                    break;
                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const TransferOrderRows = [{ id: 1 }]

    const submitHandler = (data: any): any => {
        console.log(data)
    }

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Transfer Order</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getTransferOrderColumns()} rows={TransferOrderRows} />
            <div style={{ paddingTop: "30px" }}>
                <Button variant='contained' type='submit' onClick={() => setShowTransferForm(true)} >{'Create Transfer'}</Button>
            </div>
            <TransferForm
                open={Boolean(showTransferForm)}
                closeForm={() => setShowTransferForm(false)}
            />
        </div>
    )
}

const TransferForm = ({ closeForm, open }: { open: boolean; closeForm: Function; }) => {

    const { notify } = useContext(NotificationContext)

    const getFormConfig = INV_TRANSFER_ORDER_CONFIG

    const submitHandler = (data: any): any => {
        console.log("data", data);

        notify('Form saved.')
        closeForm()
    }

    return (
        <Modal open={open} title={'Create Transfer Order'} onClose={closeForm}>
            {open ? <DynamicForm config={getFormConfig} onSubmit={submitHandler} submitText='Save' cancelText='Cancel' onCancel={() => closeForm()} /> : <></>}
        </Modal>
    )
}
